import Fetch from '../apiConfig/apiConfig';
import {
  IRecordNpsPopupShownRequest,
  IRecordNpsPopupShownResponse,
  ISubmitNpsRequest,
  IGetLastNpsShownResponse,
  INpsResponsesResult,
} from '../../types/nps';

export const recordNpsPopupShown = (
  data: IRecordNpsPopupShownRequest,
): Promise<IRecordNpsPopupShownResponse> => {
  return Fetch()
    .then(axios => axios.post('nps/popup-shown', data))
    .then(response => response.data.data);
};

export const submitNpsResponse = (data: ISubmitNpsRequest): Promise<void> => {
  return Fetch()
    .then(axios => axios.post('nps/submit', data))
    .then(() => undefined);
};

export const getLastNpsShown = (): Promise<IGetLastNpsShownResponse> => {
  return Fetch()
    .then(axios => axios.get('nps/last-shown'))
    .then(response => response.data.data);
};

export const getNpsResponses = (
  from?: string,
  to?: string,
  retailerName?: string,
  page: number = 1,
  pageSize: number = 20,
  sortBy?: string,
  sortDirection?: string,
): Promise<INpsResponsesResult> => {
  return Fetch()
    .then(axios =>
      axios.get('nps/responses', {
        params: {
          From: from,
          To: to,
          RetailerName: retailerName,
          Page: page,
          PageSize: pageSize,
          SortBy: sortBy,
          SortDirection: sortDirection,
        },
      }),
    )
    .then(response => response.data.data);
};
